import Link from '@corratech/pylot-ui/src/Link'
import s from '@corratech/air-ooka-header/Menu/DesktopMenu/DesktopMenu.module.scss'
import React from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { useTopNavTracking } from '@corratech/pylot-tag-manager/src/hooks/useMenuTracking'

export const OtherMenuItem = () => {
    const router = useRouter()
    const { t } = useTranslation('common')
    const trackMenuClick = useTopNavTracking()
    return (
        <>
            <Link
                key=""
                className={s['MainMenuLink']}
                href={`/${router?.locale}/store-locator`}
                onClick={() =>
                    trackMenuClick(
                        'FIND OOKA',
                        `/${router?.locale}/store-locator`,
                        ['store-locator']
                    )
                }
            >
                <span>{t('FIND OOKA')}</span>
            </Link>
            <Link
                key=""
                className={s['MainMenuLink']}
                href={`/${router?.locale}/ooka-for-business`}
                onClick={() =>
                    trackMenuClick(
                        'Become a partner',
                        `/${router?.locale}/ooka-for-business`,
                        ['ooka-for-business']
                    )
                }
            >
                <span>{t('Become a partner')}</span>
            </Link>
            <Link
                key=""
                className={s['MainMenuLink']}
                href={`https://find.ooka.com/${router?.locale}/ooka-home-catering`}
                // eslint-disable-next-line i18next/no-literal-string
                target="_blank"
                // @ts-ignore
                // eslint-disable-next-line i18next/no-literal-string
                rel="noopener noreferrer"
                onClick={() =>
                    trackMenuClick(
                        'CATERING',
                        `https://find.ooka.com/${router?.locale}/ooka-home-catering`,
                        ['catering']
                    )
                }
            >
                <span>{t('CATERING')}</span>
            </Link>
            <Link
                key=""
                className={s['MainMenuLink']}
                href={`/${router?.locale}/content/contact-us`}
                onClick={() =>
                    trackMenuClick(
                        'Support',
                        `/${router?.locale}/content/contact-us`,
                        ['contact-us']
                    )
                }
            >
                <span>{t('Support')}</span>
            </Link>
        </>
    )
}
